export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-secondary-950 pt-14 md:pt-20 pb-8 px-4 md:px-6">
      <div className="w-full max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10 md:mb-14">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="font-heading text-xl text-background-50 mb-4 block">
              51吃瓜大赛
            </span>
            <p className="text-sm text-background-50/60 leading-relaxed mb-4">
              专注网红爆料与明星八卦的深度内容平台，覆盖台北娜娜、莫里秀、玩偶姐姐等热门人物，每日更新最新吃瓜资讯，满足吃瓜群众深扒需求。吃瓜第一线，爆料不等待。
            </p>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-primary-500/30 transition-colors duration-200">
                <i className="ri-wechat-line text-background-50/70 text-sm"></i>
              </div>
              <div className="w-9 h-9 rounded-lg bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-primary-500/30 transition-colors duration-200">
                <i className="ri-weibo-line text-background-50/70 text-sm"></i>
              </div>
              <div className="w-9 h-9 rounded-lg bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-primary-500/30 transition-colors duration-200">
                <i className="ri-bilibili-line text-background-50/70 text-sm"></i>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: '吃瓜专题', href: '#index' },
                { label: '吃瓜热榜', href: '#ranking' },
                { label: '焦点深扒', href: '#carousel' },
                { label: '深扒图文', href: '#cards' },
                { label: '瓜友热评', href: '#comments' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(item.href);
                    }}
                    className="text-sm text-background-50/60 hover:text-accent-400 transition-colors duration-200 cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">热门话题</h3>
            <ul className="space-y-2.5">
              {[
                { label: '台北娜娜', href: '#cards' },
                { label: '莫里秀', href: '#cards' },
                { label: '玩偶姐姐', href: '#cards' },
                { label: '明星塌房', href: '#cards' },
                { label: '网红互撕', href: '#cards' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(item.href);
                    }}
                    className="text-sm text-background-50/60 hover:text-accent-400 transition-colors duration-200 cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-50/40 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40 text-center sm:text-left">
            &copy; 2024-2026 51吃瓜大赛. 本平台内容仅供娱乐参考，不构成任何投资或法律建议。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-50/30">51吃瓜台北娜娜</span>
            <span className="text-xs text-background-50/30">51吃瓜莫里秀</span>
            <span className="text-xs text-background-50/30">玩偶姐姐</span>
          </div>
        </div>
      </div>
    </footer>
  );
}